module.exports = __webpack_public_path__ + "static/media/logo.22702f43.png";